/* global Knitiv */

export default class ModalLoginWorkspacesController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {boolean} admin
	 * @param {{env_list: any, info: any}} workspaces
	 */
	constructor(
		$rootScope,
		$translate,
		$uibModalInstance,
		admin,
		workspaces,
	) {
		this.$rootScope = $rootScope;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.admin = admin;
		this.workspaces = workspaces;

		/** @type {string | undefined} */
		this.date = undefined;

		this.datePickerOptions = {
			allowInput:        true,
			altFormat:         'd/m/Y H:i:S',
			dateFormat:        'd/m/Y H:i:S',
			displayInput:      true,
			enableTime:        true,
			label:             $translate.instant('common.date'),
			placeholder:       $translate.instant('common.now'),
			static:            true,
			time_24hr:         true,
		};

		this.$rootScope.title = 'workspaces.title';
	}

	/**
	 * @param {string} environment
	 * @param {any} database
	 */
	selectWorkspace(environment, database) {
		this.$uibModalInstance.close({
			env: environment,
			database,
			date: this.date,
		});
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
